<template>
    <card>
        <card-header>Review Sites Overview</card-header>
        <card-body class="pt-0" v-if="loading">
            <card-spinner style="height: 200px;"></card-spinner>
        </card-body>
        <card-body class="d-flex align-items-center justify-content-center" v-if="!loading &amp;&amp; !review_sites_overview.length">
            <p class="lead text-black-50">No data to display</p>
        </card-body>
        <card-body class="pt-0" v-if="!loading &amp;&amp; review_sites_overview.length">
            <sites-metrics :data="review_sites_overview"></sites-metrics>
        </card-body>
    </card>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        data: () => ({
            review_sites_overview: [],
            loading              : false,
            interval             : null
        }),

        created() {
            this.loading = true;
            this.fetchReviewSitesOverview()
                .then(() => this.loading = false);

            this.interval = setInterval(this.refresh, 60000);
        },

        watch: {
            filter() {
                this.fetchReviewSitesOverview();
            }
        },

        computed: {
            ...mapState(['filter']),

            averageScore() {
                let total = 0;
                let sites = 0;

                this.review_sites_overview.map(review => {
                    if (review.data) {
                        total += review.average;
                        sites++;
                    }
                });

                if (!sites) return 0;

                return (total / sites).toFixed(2);
            }
        },

        methods: {
            async fetchReviewSitesOverview() {
                const params                        = {...this.filter, type: this.type};
                const {data: review_sites_overview} = await this.$http.get(this.$laroute.route('api.reviews.review-sites-overview'), {params});
                return this.review_sites_overview = review_sites_overview;
            },

            refresh() {
                this.loading = true;
                this.fetchReviewSitesOverview()
                    .then(() => this.loading = false)
                    .catch(() => {
                        clearInterval(this.interval);
                        window.location.reload();
                    });
            }
        },
    }
</script>
